import { render, staticRenderFns } from "./memberType.vue?vue&type=template&id=c62ad1a6&scoped=true&"
import script from "./memberType.vue?vue&type=script&lang=js&"
export * from "./memberType.vue?vue&type=script&lang=js&"
import style0 from "./memberType.vue?vue&type=style&index=0&id=c62ad1a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c62ad1a6",
  null
  
)

export default component.exports